<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Native Unit (нативный текстово-графический блок)</div>
    <div class="markup__h markup__h_3">
      Данное размещение содержит - картинку, лого, текст, кнопку перехода.
    </div>
    <br>
    <router-link to="/mobile/mobileNativeUnit" target="_blank" class="link">Демо формата</router-link>
    <br><br>

    <div class="attention attention_info">
      <div class="attention__title">Рекомендации для улучшения качества размещения: </div>
      <p>Чтобы максимизировать отдачу от формата, текст не должен содержать прямой рекламы. Он должен быть выполнен в стилистике новостного заголовка. </p>
      <p>Наличие 3-4 вариантов изображений, а также заголовков и описаний. В ходе РК мы проведём A/B тесты и оставим активными наиболее эффективные креативы.</p>
    </div>
    <br><br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Изображение:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>
            должно быть предоставлено в пяти размерах:
            <ul class="markup__ul markup__ul_nested">
              <li><span>Ш:В</span><strong>1000px : 1000px</strong><span>(1:1)</span></li>
              <li><span>Ш:В</span><strong>1000px : 750px</strong><span>(4:3)</span></li>
              <li><span>Ш:В</span><strong>1000px : 667px</strong><span>(3:2)</span></li>
              <li><span>Ш:В</span><strong>1000px : 625px</strong><span>(16:10)</span></li>
              <li><span>Ш:В</span><strong>1000px : 563px</strong><span>(16:9)</span></li>
            </ul>
          </li>
          <li>Формат: PNG</li>
          <li>Максимальный вес изображения — 1 МБ</li>
          <li>Не размещайте на изображениях тексты, логотипы, кнопки и другие элементы. Для этого в объявлении есть специально предназначенные поля.</li>
          <li>В названии файлов картинок необходимо указать пропорции изображения. <strong>Например, 4x3.png</strong></li>
          <li>Все символы в названии файлов картинок должны быть прописаны <strong>только</strong> в английской раскладке</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Логотип:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PNG</li>
          <li>Прозрачный фон</li>
          <li>Соотношение сторон: рекомендуется 1:1</li>
          <li>Размеры: рекомендуется ширина 200px</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Текстовое написание бренда</strong>
        </div>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Текст (с учетом пробелов):</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Заголовок: до 50 символов</li>
          <li>
            <p>Описание: до 60 символов</p>
            <div class="attention attention_warn">
              <p>Основной смысл рекламного сообщения должен содержаться именно в заголовке, так как дополнительный текст-описание отображается не на всех площадках.</p>
            </div>
          </li>
        </ul>
        <div class="html2pdf__page-break"/>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Кнопка:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Текст: до 20 символов</li>
          <li>
            Внешний вид: дефолтный или кастомизированный. Есть возможность изменить внешний вид, использовав готовый дизайн клиента (необходимо предоставить готовую кнопоку в PNG или макеты PSD / FIGMA / AI), либо мы можем подготовить дизайн кнопки самостоятельно.
          </li>
        </ul>
      </li>
    </ul>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'mobileNativeUnit',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

.markup__ul_nested span
  margin 0 10px

</style>
